'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var jacketCoverShape = _react.PropTypes.shape({
  type: _react.PropTypes.string,
  smallCover: _react.PropTypes.string,
  mediumCover: _react.PropTypes.string,
  largeCover: _react.PropTypes.string,
  localUrl: _react.PropTypes.string
});

var bibListItemShape = _react.PropTypes.shape({
  id: _react.PropTypes.string,
  title: _react.PropTypes.string,
  authors: _react.PropTypes.arrayOf(_react.PropTypes.string),
  format: _react.PropTypes.string,
  pubYear: _react.PropTypes.string
});

var urlListItemShape = _react.PropTypes.shape({
  url: {
    title: _react.PropTypes.string,
    url: _react.PropTypes.string
  }
});

var listItemShape = _react.PropTypes.oneOfType([_react.PropTypes.shape({
  id: _react.PropTypes.number,
  type: _react.PropTypes.string.isRequired,
  bibListItem: bibListItemShape.isRequired,
  annotation: _react.PropTypes.string,
  jacketCover: jacketCoverShape
}), _react.PropTypes.shape({
  id: _react.PropTypes.number,
  type: _react.PropTypes.string.isRequired,
  urlListItem: urlListItemShape.isRequired,
  annotation: _react.PropTypes.string,
  jacketCover: jacketCoverShape
})]);

exports.default = listItemShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/bc-prop-types/lib/components/listItemShape.js
// module id = 359
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15